import type { TableSemanticSchema } from './types';

export const MoscowSchema: TableSemanticSchema = {
  id: 'moscow',
  name: 'MoSCoW Prioritization',
  description:
    'Must / Should / Could / Won’t buckets with rationale. Commonly used in agile release scoping.',
  cells: [
    { id: 'must', label: 'Must Have', row: 0, col: 0, accent: '#dc2626' },
    { id: 'should', label: 'Should Have', row: 1, col: 0, accent: '#f59e0b' },
    { id: 'could', label: 'Could Have', row: 2, col: 0, accent: '#2563eb' },
    { id: 'wont', label: "Won't Have (this round)", row: 3, col: 0, accent: '#64748b' },
  ],
  itemFields: [
    { key: 'category', label: 'Category', kind: 'enum', required: true,
      options: [
        { value: 'must', label: 'Must' },
        { value: 'should', label: 'Should' },
        { value: 'could', label: 'Could' },
        { value: 'wont', label: "Won't" },
      ] },
    { key: 'rationale', label: 'Rationale', kind: 'string' },
    { key: 'release', label: 'Release', kind: 'string' },
  ],
  renderingHints: { layout: 'stack' },
};
